var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// ./~/moment-timezone/index.js
// module id = 668
// module chunks = 0